import { render, staticRenderFns } from "./ConfirmationDialogOwnersInActivity.vue?vue&type=template&id=bed0cce2"
import script from "./ConfirmationDialogOwnersInActivity.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogOwnersInActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports